import { useAssetUrl } from "../../state/use-asset-url.js";

/**
 * AssetId 기반 lazy 이미지(결정 #18). objectURL을 화면에 있을 때만 만들고
 * 언마운트 시 자동 revoke한다(useAssetUrl). 아바타/갤러리 썸네일 공용.
 */
export function AssetImage({
  assetId,
  alt,
  className,
  fallback,
}: {
  assetId: string | undefined;
  alt: string;
  className?: string;
  /** 에셋이 없을 때 보여줄 대체 노드(이니셜 등). */
  fallback?: React.ReactNode;
}) {
  const url = useAssetUrl(assetId);

  if (!url) {
    return (
      <div className={[className, "flex items-center justify-center bg-bg-raised text-ink-faint"].join(" ")}>
        {fallback ?? null}
      </div>
    );
  }

  return <img src={url} alt={alt} loading="lazy" className={className} />;
}
